import { createContext, useContext, useMemo } from "react";
import { ISchoolYearService } from "../services/SchoolYearService";
import { useHttpRequestService } from "./HttpRequestContext";
import { createSchoolYearService } from "./Bootstrap";

const SchoolYearContext = createContext<ISchoolYearService | null>(null);

export const SchoolYearProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const schoolYearService = useMemo(() => createSchoolYearService(httpRequestService), [httpRequestService]);
    return (
        <SchoolYearContext.Provider value={schoolYearService}>
            {children}
        </SchoolYearContext.Provider>
    );
}

export const useSchoolYearService = () => {
    const schoolYearService = useContext(SchoolYearContext);
    if (!schoolYearService) {
        throw new Error('useSchoolYearService must be used within a SchoolYearProvider');
    }
    return schoolYearService;
};
